window.addEventListener("load", function () {
  const container = document.getElementById("imagessliderContainer");
  if (!container) return;
  const slider = document.getElementById("instagramSlider");
  let isDown = false;
  let startX;
  let currentTranslate = 0;
  let prevTranslate = 0;
  const dummyImages = [
    "https://picsum.photos/id/10/400/400",
    "https://picsum.photos/id/20/400/400",
    "https://picsum.photos/id/30/400/400",
    "https://picsum.photos/id/40/400/400",
    "https://picsum.photos/id/50/400/400",
    "https://picsum.photos/id/10/400/400",
    "https://picsum.photos/id/30/400/400",
    "https://picsum.photos/id/40/400/400",
  ];
  function remToPx(rem) {
    return (
      rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    );
  }
  function buildSlider(urls) {
    slider.innerHTML = "";
    const itemWidth = remToPx(14.5);
    const gap = 8;
    const totalContentWidth = urls.length * itemWidth + (urls.length - 1) * gap;
    if (totalContentWidth > container.offsetWidth) {
      slider.classList.replace("justify-center", "justify-start");
    } else {
      slider.classList.replace("justify-start", "justify-center");
      currentTranslate = 0;
      slider.style.transform = `translateX(0px)`;
    }
    urls.forEach((url) => {
      const slide = document.createElement("div");
      slide.className = "shrink-0 w-[14.5rem] h-[14.5rem] overflow-hidden";
      const img = document.createElement("img");
      img.src = url;
      img.className = "w-full h-full object-cover pointer-events-none";
      slide.appendChild(img);
      slider.appendChild(slide);
    });
  }
  const handleStart = (e) => {
    if (slider.scrollWidth <= container.offsetWidth) return;
    isDown = true;
    startX = (e.pageX || e.touches[0].pageX) - slider.offsetLeft;
    prevTranslate = currentTranslate;
    slider.style.transition = "none";
  };
  const handleEnd = () => {
    if (!isDown) return;
    isDown = false;
    slider.style.transition = "transform 0.3s ease-out";
    const maxScroll = Math.min(0, container.offsetWidth - slider.scrollWidth);
    if (currentTranslate > 0) currentTranslate = 0;
    if (currentTranslate < maxScroll) currentTranslate = maxScroll;
    slider.style.transform = `translateX(${currentTranslate}px) translateZ(0)`;
  };

  const handleMove = (e) => {
    if (!isDown) return;
    const x = (e.pageX || e.touches[0].pageX) - slider.offsetLeft;
    const walk = (x - startX) * 1.3;
    currentTranslate = prevTranslate + walk;
    slider.style.transform = `translateX(${currentTranslate}px) translateZ(0)`;
  };
  container.addEventListener("mousedown", handleStart);
  container.addEventListener("touchstart", handleStart, { passive: true });
  window.addEventListener("mouseup", handleEnd);
  window.addEventListener("touchend", handleEnd);
  window.addEventListener("mousemove", handleMove);
  window.addEventListener("touchmove", handleMove, { passive: false });
  fetch(`${envConfig.INSTAGRAM_FEED_ENDPOINT}`, {
    headers: { Authorization: `Bearer ${envConfig.INSTAGRAM_SECRET_KEY}` },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      const urls = data.images || (Array.isArray(data) ? data : []);
      if (urls && urls.length > 0) {
        buildSlider(urls.slice(0, 12));
      } else {
        throw new Error("Empty feed array");
      }
    })
    .catch((err) => {
      buildSlider(dummyImages);
    });
  window.addEventListener("resize", () => {
    const itemWidth = remToPx(14.5);
    const totalContentWidth =
      slider.children.length * itemWidth + (slider.children.length - 1) * 8;
    if (totalContentWidth > container.offsetWidth) {
      slider.classList.replace("justify-center", "justify-start");
    } else {
      slider.classList.replace("justify-start", "justify-center");
      currentTranslate = 0;
      slider.style.transform = `translateX(0px)`;
    }
  });
});
